import React from "react";
import { Card, Descriptions, PageHeader, Button } from "antd";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const ViewVehicleData = (props) => {
  const handleDownloadPDF = () => {
    const element = document.getElementById("view-profile");
    html2canvas(element, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("VehicleDetails.pdf");
    });
  };
  console.log("props", props);

  return (
    <div id="view-profile">
      <div style={{ padding: "20px 0" }}>
        <PageHeader
          onBack={false}
          title="Vehicle Details"
          extra={[
            <Button type="primary" onClick={handleDownloadPDF}>
              Download PDF
            </Button>,
          ]}
        >
          <Card className="viewCard">
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">RC Number</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.rc_number
                    ? props?.data?.rc_number
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Full Name</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.owner_name
                    ? props?.data?.owner_name
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Insurance Upto</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.insurance_upto
                    ? moment(props?.data?.insurance_upto).format("DD/MM/YYYY")
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Father Name</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.father_name
                    ? props?.data?.father_name
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Financed</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.financed
                    ? props?.data?.financed
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Fuel Type</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.fuel_type
                    ? props?.data?.fuel_type
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Fit Upto</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.fit_up_to
                    ? moment(props?.data?.fit_up_to).format("DD/MM/YYYY")
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Make Model</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.maker_model
                    ? props?.data?.maker_model
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Body Type</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.body_type
                    ? props?.data?.body_type
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Color</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.color ? props?.data?.color : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Cubic Capacity</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.cubic_capacity
                    ? props?.data?.cubic_capacity
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Registration Date</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.registration_date
                    ? moment(props?.data?.registration_date).format(
                        "DD/MM/YYYY"
                      )
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Insurance Company</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.insurance_company
                    ? props?.data?.insurance_company
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={
                  <span className="sub-heading">Insurance Policy Number</span>
                }
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.insurance_policy_number
                    ? props?.data?.insurance_policy_number
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Latest By</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.latest_by
                    ? moment(props?.data?.latest_by).format("DD/MM/YYYY")
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Tax Paid Upto</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.tax_paid_upto
                    ? props?.data?.tax_paid_upto
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Maker Description</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.maker_description
                    ? props?.data?.maker_description
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Manufacturing Date</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.manufacturing_date_formatted
                    ? moment(props?.data?.manufacturing_date_formatted).format(
                        "DD/MM/YYYY"
                      )
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">No Cylinders</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.no_cylinders
                    ? props?.data?.no_cylinders
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Norms Type</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.norms_type
                    ? props?.data?.norms_type
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Owner Number</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.owner_number
                    ? props?.data?.owner_number
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Permanent Address</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.permanent_address
                    ? props?.data?.permanent_address
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Reason</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.type ? props?.data?.type : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Details</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.details
                    ? props?.data?.details
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Present Address</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.norms_type
                    ? props?.data?.norms_type
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Seat Capacity</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.seat_capacity
                    ? props?.data?.seat_capacity
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Pucc Number</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.pucc_number
                    ? props?.data?.pucc_number
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Pucc Upto</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.pucc_upto
                    ? moment(props?.data?.pucc_upto).format("DD/MM/YYYY")
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Registered At</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.registered_at
                    ? props?.data?.registered_at
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Tax Upto</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.tax_upto
                    ? moment(props?.data?.tax_upto).format("DD/MM/YYYY")
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Unladen Weight</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.unladen_weight
                    ? props?.data?.unladen_weight
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Vehicle Category</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.vehicle_category
                    ? props?.data?.vehicle_category
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={
                  <span className="sub-heading">
                    Vehicle Category Description
                  </span>
                }
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.vehicle_category_description
                    ? props?.data?.vehicle_category_description
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={
                  <span className="sub-heading">Vehicle Chasi Number</span>
                }
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.vehicle_chasi_number
                    ? props?.data?.vehicle_chasi_number
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={
                  <span className="sub-heading">Vehicle Engine Number</span>
                }
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.vehicle_engine_number
                    ? props?.data?.vehicle_engine_number
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={
                  <span className="sub-heading">Vehicle Gross Weight</span>
                }
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.vehicle_gross_weight
                    ? props?.data?.vehicle_gross_weight
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Blacklist Status</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.blacklist_status
                    ? props?.data?.blacklist_status
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Challan Details</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.challan_details
                    ? props?.data?.challan_details
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Financer</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.financer
                    ? props?.data?.financer
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Mobile Number</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.mobile_number
                    ? props?.data?.mobile_number
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={
                  <span className="sub-heading">National Permit Issued By</span>
                }
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.national_permit_issued_by
                    ? props?.data?.national_permit_issued_by
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={
                  <span className="sub-heading">National Permit Number</span>
                }
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.national_permit_number
                    ? props?.data?.national_permit_number
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={
                  <span className="sub-heading">National Permit Upto</span>
                }
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.national_permit_upto
                    ? props?.data?.national_permit_upto
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Masked Name</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.masked_name
                    ? props?.data?.masked_name
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Noc Details</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.noc_details
                    ? props?.data?.noc_details
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Non Use From</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.non_use_from
                    ? props?.data?.non_use_from
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Non Use Status</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.non_use_status
                    ? props?.data?.non_use_status
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Non Use To</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.non_use_to
                    ? props?.data?.non_use_to
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Permit Issue Date</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.permit_issue_date
                    ? props?.data?.permit_issue_date
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Permit Number</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.permit_number
                    ? props?.data?.permit_number
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Permit Type</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.permit_type
                    ? props?.data?.permit_type
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Permit Valid From</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.permit_valid_from
                    ? props?.data?.permit_valid_from
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Permit Valid Upto</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.permit_valid_upto
                    ? props?.data?.permit_valid_upto
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Rc Status</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.rc_status
                    ? props?.data?.rc_status
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">RTO Code</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.rto_code
                    ? props?.data?.rto_code
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Sleeper Capacity</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.sleeper_capacity
                    ? props?.data?.sleeper_capacity
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Standing Capacity</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.standing_capacity
                    ? props?.data?.standing_capacity
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Variant</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.variant
                    ? props?.data?.variant
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Wheelbase</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.wheelbase
                    ? props?.data?.wheelbase
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Less Info</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.less_info
                    ? props?.data?.less_info
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </PageHeader>
      </div>
    </div>
  );
};
